import { render, staticRenderFns } from "./colEstadoCompras.vue?vue&type=template&id=178d0f9a&"
import script from "./colEstadoCompras.vue?vue&type=script&lang=js&"
export * from "./colEstadoCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports